import http from 'utils/http';
import { generateURLWithParams } from 'utils';

export const fetchInvoices = (params) => {
  const url = generateURLWithParams('v1/organizations/{{organizationId}}/invoices/', params);
  return http.get(url);
};
